export default __webpack_public_path__ + "static/media/Voittaja_Myyja.8e83ce75.gif";